export default "__VITE_ASSET__Ci31tA91__"